<template>
  <v-container v-if="user" fluid>
    <v-card>
      <v-card-title class="blue lighten-2 black--text"
        >Estados Contables
      </v-card-title>
      <v-col>
        <v-row>
          <v-col cols="2" class="ml-4">
            <v-select
              v-model="TipoDocumento"
              :items="itemsDocumentos"
              label="Tipo de documento"
              required
            ></v-select>
          </v-col>
          <v-col cols="2" class="ml-4">
            <v-text-field
              label="Fecha inicio"
              v-model="fecha_inicio"
              placeholder="AAAA-MM-DD"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div :elevation="0" dark v-bind="attrs" v-on="on">
                  <SeleccionarFecha @enviar-datos="selectFechaInicio" />
                </div>
              </template>
              <span>Abrir calendario</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="ml-4">
            <v-text-field
              label="Fecha fin"
              v-model="fecha_fin"
              placeholder="AAAA-MM-DD"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div :elevation="0" dark v-bind="attrs" v-on="on">
                  <SeleccionarFecha @enviar-datos="selectFechaFin" />
                </div>
              </template>
              <span>Abrir calendario</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="mb-1 ml-1">
          <div v-for="(sucursal, index) in sucursalesCheckbox" :key="index">
            <v-col>
              <label>
                <input
                  type="checkbox"
                  v-model="checkboxValues"
                  :value="sucursal.value"
                />
                {{ sucursal.text }}
              </label>
            </v-col>
          </div>
        </v-row>
        <v-col cols="12" class="text-center">
          <v-btn
            color="blue lighten-2"
            @click="buscarEstadosContables"
            class="ml-2"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-col>

      <v-data-table
        v-if="items.length > 0"
        :headers="headersContables"
        :items="filteredItems"
        :search="search"
        :items-per-page="50"
        no-data-text="No hay resultados"
        class="bg-header ma-3"
      >
        <template v-slot:top>
          <v-row class="" v-if="items.length > 0">
            <v-col cols="3" class="ml-4">
              <v-text-field
                v-model="search"
                label="Buscar"
                append-icon="mdi-magnify"
                outlined
              />
            </v-col>
            <v-col cols="3" class="ml-4">
              <v-select
                v-model="filtroEstadoContable"
                :items="estadoContable"
                item-text="text"
                item-value="value"
                label="Filtrar por estado contable"
                outlined
                class="ml-2"
                clearable
              />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="3" class="mt-4 align-end justify-end">
              <v-btn color="blue lighten-2" @click="downloadExcel" class="ml-2">
                Descargar Excel
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.sucursal`]="{ item }">
          {{ item.sucursal }}
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          {{ formatDate(item.fecha) }}
        </template>
        <template v-slot:[`item.tipo_documento`]="{ item }">
          {{ item.tipo_documento }}
        </template>
        <template v-slot:[`item.concepto`]="{ item }">
          {{ item.concepto }}
        </template>
        <template v-slot:[`item.serie_folio`]="{ item }">
          {{ item.serie_folio }}
        </template>
        <template v-slot:[`item.neto`]="{ item }">
          {{ "$" + item.neto }}
        </template>
        <template v-slot:[`item.iva`]="{ item }">
          {{ "$" + item.iva }}
        </template>
        <template v-slot:[`item.ieps`]="{ item }">
          {{ "$" + item.ieps }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ "$" + item.total }}
        </template>
        <template v-slot:[`item.codigo_cliente_proveedor`]="{ item }">
          {{ item.codigo_cliente_proveedor }}
        </template>
        <template v-slot:[`item.rfc`]="{ item }">
          {{ item.rfc }}
        </template>
        <template v-slot:[`item.razon_social`]="{ item }">
          {{ item.razon_social }}
        </template>
        <template v-slot:[`item.estado_contable`]="{ item }">
          {{ estadoFormateado[item.estado_contable] || item.estado_contable }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ExcelJS from "exceljs";
import SeleccionarFecha from "@/components/SeleccionarFecha.vue";
export default {
  data() {
    return {
      search: "",
      filtroEstadoContable: "",
      TipoDocumento: "",
      itemsDocumentos: ["Ventas", "Compras", "Ambos"],
      items: [],
      fecha_inicio: "",
      fecha_fin: "",
      selectedOption: "",
      datos: {},
      sucursalesCheckbox: [
        {
          text: "Mexicali",
          value: "Mexicali",
        },
        {
          text: "Tijuana",
          value: "Tijuana",
        },
        {
          text: "Ensenada",
          value: "Ensenada",
        },
        {
          text: "La Paz",
          value: "LaPaz",
        },
        {
          text: "Obregón",
          value: "Obregon",
        },
        {
          text: "Hermosillo",
          value: "Hermosillo",
        },
      ],
      checkboxValues: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
      headersContables: [
        { text: "Sucursal", value: "sucursal" },
        { text: "Fecha", value: "fecha" },
        { text: "Tipo de Documento", value: "modelo" },
        { text: "Concepto", value: "concepto" },
        { text: "Serie y Folio", value: "serie_folio" },
        { text: "Neto", value: "neto" },
        { text: "IVA", value: "iva" },
        { text: "IEPS", value: "ieps" },
        { text: "Total", value: "total" },
        { text: "Codigo cliente Proveedor", value: "codigo_cliente_proveedor" },
        { text: "RFC", value: "rfc" },
        { text: "Razon Social", value: "razon_social" },
        { text: "Estado Contable", value: "estado_contable" },
      ],
      estadoContable: [
        { value: "no_contabilizado", text: "No Contabilizado" },
        {
          value: "pertenece_a_una_prepoliza_de_documento",
          text: "Pertenece a una Prepóliza de documento",
        },
        {
          value: "pertenece_a_una_prepoliza_diaria",
          text: "Pertenece a una Prepóliza Diaria",
        },
        {
          value: "pertenece_a_una_prepoliza_por_periodo",
          text: "Pertenece a una Prepóliza por Periodo",
        },
        {
          value: "pertenece_a_una_poliza_de_documento",
          text: "Pertenece a una Póliza de documento",
        },
        {
          value: "pertenece_a_una_poliza_diaria",
          text: "Pertenece a una Póliza Diaria",
        },
        {
          value: "pertenece_a_una_poliza_por_periodo",
          text: "Pertenece a una Póliza por Periodo",
        },
        {
          value: "pertenece_a_una_poliza_modificada_contabilizadalibremente",
          text: "Pertenece a una Póliza modificada (contabilizada libremente)",
        },
      ],
      estadoFormateado: {
        no_contabilizado: "No Contabilizado",
        pertenece_a_una_prepoliza_de_documento:
          "Pertenece a una Prepóliza de documento",
        pertenece_a_una_prepoliza_diaria: "Pertenece a una Prepóliza Diaria",
        pertenece_a_una_prepoliza_por_periodo:
          "Pertenece a una Prepóliza por Periodo",
        pertenece_a_una_poliza_de_documento:
          "Pertenece a una Póliza de documento",
        pertenece_a_una_poliza_diaria: "Pertenece a una Póliza Diaria",
        pertenece_a_una_poliza_por_periodo:
          "Pertenece a una Póliza por Periodo",
        pertenece_a_una_poliza_modificada_contabilizadalibremente:
          "Pertenece a una Póliza modificada (contabilizada libremente)",
      },
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    async buscarEstadosContables() {
      try {
        let resultados = [];
        if (!this.checkboxValues.length) {
          this.items = [];
          return;
        }

        // Una petición por sucursal
        const peticiones = this.checkboxValues.map((sucursal) => {
          return axios.get(
            `/reportes/get_estados_contables?fecha_inicial=${this.fecha_inicio}&fecha_final=${this.fecha_fin}&sucursal=${sucursal}&tipo_documentos=${this.TipoDocumento}`
          );
        });

        const respuestas = await Promise.all(peticiones);

        respuestas.forEach((res) => {
          if (
            res.data &&
            Array.isArray(res.data.data) &&
            Array.isArray(res.data.columns)
          ) {
            // Convierte cada fila en objeto usando columns como claves
            const filas = res.data.data.map((fila) => {
              const obj = {};
              res.data.columns.forEach((col, idx) => {
                obj[col] = fila[idx];
              });
              obj.serie_folio = `${obj.serie} - ${obj.folio}`;
              return obj;
            });
            resultados = resultados.concat(filas);
          }
        });

        this.items = resultados;
      } catch (error) {
        console.error("Error al buscar estados contables:", error);
        alert(
          "Error al buscar estados contables. Por favor, inténtelo de nuevo."
        );
      }
    },

    downloadExcel() {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Estados Contables");
        worksheet.columns = this.headersContables.map((header) => ({
          header: header.text,
          key: header.value,
          width: 20,
        }));

        this.items.forEach((item) => {
          worksheet.addRow(item);
        });
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { horizontal: "center" };
        worksheet.getRow(1).eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFB0BEC5" },
          };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "EstadosContables.xlsx";
          link.click();
          URL.revokeObjectURL(url);
        });
      } catch (error) {
        console.error("Error al descargar el archivo:", error);
        alert("Error al descargar el archivo. Por favor, inténtelo de nuevo.");
      }
    },

    selectFechaInicio(fechaInicio) {
      this.fecha_inicio = fechaInicio;
      this.mostrarHijo = false;
    },
    selectFechaFin(fechaFin) {
      this.fecha_fin = fechaFin;
      this.mostrarHijo = false;
    },
  },
  components: { SeleccionarFecha },
  created() {},
  computed: {
    ...mapGetters(["user"]),

    filteredItems() {
      let items = this.items;
      if (this.filtroEstadoContable) {
        items = items.filter(
          (item) => item.estado_contable === this.filtroEstadoContable
        );
      }
      return items;
    },
  },
};
</script>

<style scoped>
.bg-header {
  background-color: #e3f2fd;
}
</style>
